// @ts-strict-ignore
import {
  projectTopCreatorsClient,
  ProjectTopCreatorsResponse,
  TopCreator,
} from 'common/report/queries/app-api/project-top-creators';
import {ApiSingleValueResource} from 'common/util/model-resource/api-resource';

import {getProjectId} from '../util';

export class ProjectTopCreatorsResource extends ApiSingleValueResource<ProjectTopCreatorsResponse> {
  apiClient = projectTopCreatorsClient;

  constructor({projectId = null, urlManager = null} = {}) {
    super();
    this.id = projectId ?? getProjectId(urlManager);
  }

  getCreators(): TopCreator[] {
    return this.get().value?.creators ?? [];
  }

  hasViewedContent(): boolean {
    return this.get().value?.has_viewed_content ?? true;
  }
}
